// import axiosIn, { CancelTokenSource } from 'axios'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { ENDPOINTS } from 'const/endpoints'
import _ from 'lodash'
import axios from 'axios'
import {
	getAllCity,
	getMemberPartnerList,
	getMemberPartnerListForMessages,
	getStats,
} from './MemberDashboard.service'
import { onGetCustomSectionDetail } from 'utils/common'
import { SECTION_NAME } from 'const/common'
import { onCreateDynamicTilesData } from 'modules/AdminDashboard/Dashboard.hooks'
import { IAxiosResponseWithPagination } from 'types/entities'
import { IFullProvider, IProvidersParams } from 'modules/Providers/Provider.interfaces'

export function getAllCityList(params: any): any {
	return useQuery<any>(
		[ENDPOINTS.CITY_LIST, params?.citySearch, params?.stateID],
		() => {
			const CancelToken = axios.CancelToken
			const source = CancelToken.source()
			return getAllCity(params, source)
		},
		{
			keepPreviousData: true,
			refetchOnWindowFocus: false,
			enabled: !!params?.state,
			suspense: false,
		},
	)
}

export function useDashboardStats(currentDate: any, clientId: string | undefined) {
	return useQuery<any>(
		[`${ENDPOINTS.DASHBOARD_STATS}`, currentDate, clientId],
		() => {
			return getStats({ currentDate }, clientId)
		},
		{
			keepPreviousData: true,
			refetchOnWindowFocus: false,
			staleTime: Infinity,
			suspense: false,
		},
	)
}

export const onCreateMemberTilesDetails = (screenDetails: any, data: any) => {
	const tileInfoIObj: any = {
		totalEnrollmentsCount: data?.totalPatients ?? '0',
		referralsCount: data?.refferal ?? '--',
		abnormalVitalAlertsCount: data?.abnormal ?? '--',
		noReadingFor48HoursCount: data?.noReadingFor48Hours ?? '0',
		membersWithIncompleteMDEsCount: data?.incompleteMde ?? '--',
		appointmentsCount: data?.appointments ?? '--',
	}
	const getCustomSectionDetails = onGetCustomSectionDetail(
		screenDetails,
		SECTION_NAME?.PROVIDER_DASHBOARD,
	)
	const getTilesWithData = onCreateDynamicTilesData({ getCustomSectionDetails, data, tileInfoIObj })

	return getTilesWithData ?? []
}

//  new created
interface IGetPartnerListingByClientQueryProps
	extends UseQueryOptions<IAxiosResponseWithPagination<Partial<IFullProvider>>>,
		Partial<IProvidersParams> {
	isEnabled?: boolean
}
export function useGetMemberPartnerList({
	limit,
	page,
	search,
	isEnabled = true,
	...rest
}: IGetPartnerListingByClientQueryProps = {}) {
	return useQuery<
		IAxiosResponseWithPagination<Partial<IFullProvider>>,
		any,
		IAxiosResponseWithPagination<Partial<IFullProvider>>
	>(
		[ENDPOINTS.PARTNER_LIST_BY_CLIENT, limit, page, search],
		() => {
			const CancelToken = axios.CancelToken
			const source = CancelToken.source()
			return getMemberPartnerList({ limit, page, search }, source)
		},
		{
			suspense: false,
			keepPreviousData: true,
			refetchOnWindowFocus: false,
			...rest,
			enabled: isEnabled,
		},
	)
}
// New hook for messages
interface useGetMemberPartnerListForMessages
	extends UseQueryOptions<IAxiosResponseWithPagination<Partial<IFullProvider>>>,
		Partial<IProvidersParams> {
	isEnabled?: boolean
}
export function useGetMemberPartnerListForMessages({
	limit,
	page,
	search,
	program,
	isEnabled = true,
	...rest
}: useGetMemberPartnerListForMessages = {}) {
	return useQuery<
		IAxiosResponseWithPagination<Partial<IFullProvider>>,
		any,
		IAxiosResponseWithPagination<Partial<IFullProvider>>
	>(
		[ENDPOINTS.MEMBER_PARTNERS, limit, page, search, program],
		() => {
			const CancelToken = axios.CancelToken
			const source = CancelToken.source()
			return getMemberPartnerListForMessages({ limit, page, search, program }, source)
		},
		{
			suspense: false,
			keepPreviousData: true,
			refetchOnWindowFocus: false,
			...rest,
			enabled: isEnabled,
		},
	)
}
